/**文献对比分析头部操作栏 */
<template>
  <div class="comparison-header-bar">
    <div class="header-title">
      <TextEditor
        class="title"
        :text="comparisonTitle"
        v-model:edit="ifTitleEditing"
        v-model:loading="ifTitleLoading"
        @save="(text) => handleClickSaveTitle(text)"
      />
    </div>
    <div class="header-operate">
      <el-button class="review-button" type="primary" @click="goReview">
        <i class="iconfont icon-zixizongjie" />
        文献综述
      </el-button>
      <el-button
        class="export-button"
        type="default"
        @click="handleClickExport"
      >
        <i class="iconfont icon-daochu1" />
        导出
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits, onMounted } from "vue";
import VueCookies from "vue-cookies";
import { useRoute, useRouter } from "vue-router";
import { getUserPermission } from "@/utils/utils.js";
import { ElMessage } from "element-plus";
import { httpPost } from "@/api/httpService.js";
import TextEditor from "@/components/base/TextEditor.vue";

const router = useRouter();

const emits = defineEmits(["go-review", "export"]);

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
});

//获取对比标题
const comparisonTitle = ref("");
const comparisonUid = ref("");
watch(
  () => props.title,
  (newVal, oldVal) => {
    if (newVal) {
      comparisonTitle.value = newVal;
    }
  },
  { immediate: true, deep: true }
);
watch(
  () => props.id,
  (newVal, oldVal) => {
    comparisonUid.value = newVal;
  },
  { immediate: true, deep: true }
);

//#region 标题相关
//编辑标题
const ifTitleEditing = ref(false);
const ifTitleLoading = ref(false);
const handleClickSaveTitle = async (value) => {
  comparisonTitle.value = value;
  await saveTitle(value);
  ifTitleEditing.value = false;
  ifTitleLoading.value = false;
};
const saveTitle = async (value) => {
  let params = {
    comparisonLogUid: comparisonUid.value,
    title: value,
  };
  let res = await httpPost("/comparison/v1/updateComparisonLogTitle", params);
  if (res.code == 0) {
    ElMessage.success("修改成功");
  }
};
//#endregion 标题相关

//导出格式引文
const handleClickExport = () => {
  emits("export");
};
//打开文献综述
const goReview = () => {
  emits("go-review");
};
</script>

<style lang="scss" scoped>
.comparison-header-bar {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  position: relative;
  .header-title {
    font-size: 16px;
    font-weight: 550;
    display: flex;
    align-items: center;
    .title {
      :deep(.list-item) {
        .text {
          white-space: nowrap;
          max-width: 500px;
        }
      }
    }
  }
  .header-operate {
    display: flex;
    .review-button {
      margin-left: 15px;
      .iconfont {
        margin-right: 5px;
        font-size: 14px;
      }
    }
    .export-button {
      margin-left: 15px;
      .iconfont {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
}
</style>
